import { render, staticRenderFns } from "./ks-investor-5.vue?vue&type=template&id=01a7ade3"
var script = {}
import style0 from "./ks-investor-5.vue?vue&type=style&index=0&id=01a7ade3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports